import { Card, CardContent } from "@mui/material";

const CardBox = ({
    children,
    noPadding = false,
    hover,
    interactive = false,
    tone = "default",
    sx = {},
}) => {
    const resolvedInteractive = hover ?? interactive;

    const toneStyles = {
        default: {
            borderColor: "rgba(148,163,184,0.22)",
            background:
                "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(248,250,252,0.96) 100%)",
        },
        highlight: {
            borderColor: "rgba(148,163,184,0.28)",
            background:
                "linear-gradient(135deg, rgba(248,250,252,1) 0%, rgba(239,246,255,0.95) 100%)",
        },
        muted: {
            borderColor: "rgba(148,163,184,0.2)",
            background:
                "linear-gradient(180deg, rgba(248,250,252,0.92) 0%, rgba(255,255,255,1) 100%)",
        },
    };

    return (
        <Card
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                border: "1px solid",
                ...toneStyles[tone],
                boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)",
                borderRadius: 3,
                transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
                overflow: "hidden",

                ...(resolvedInteractive && {
                    "&:hover": {
                        transform: "translateY(-1px)",
                        boxShadow: "0 16px 36px rgba(15, 23, 42, 0.08)",
                        borderColor: "rgba(96,165,250,0.28)",
                    },
                }),

                ...sx,
            }}
        >
            <CardContent
                sx={{
                    flex: 1,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",

                    p: noPadding ? 0 : { xs: 1.5, sm: 2, md: 2.5 },

                    "&:last-child": {
                        pb: noPadding ? 0 : { xs: 1.5, sm: 2, md: 2.5 },
                    },
                }}
            >
                {children}
            </CardContent>
        </Card>
    );
};

export default CardBox;
